// Central configuration for the API layer — the SINGLE source of truth.
//
// Nothing else in `src/api` should read `process.env` or hardcode header
// names / storage keys directly. Import from here instead. This is what lets
// the whole layer be retargeted (new base URL, renamed header, etc.) by
// editing one file.
//
// NOTE: the storage keys below intentionally match the keys the legacy Redux
// `apiRequest` thunk already uses (`token` / `user` / `tenant` / `auth_type`).
// That shared contract is what allows the new TanStack Query layer and the old
// Redux layer to coexist — a session logged in via either works in both.

// Base URL of the backend API. CRA inlines `REACT_APP_*` vars at build time.
// Falls back to the live staging backend so the app still boots if the env
// var is missing (e.g. a fresh checkout without `.env.local`).
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://moadk.com/api";

// Canonical multi-tenant header. The OpenAPI spec uses three casings
// (`X-Tenant` / `x-tenant` / `X-tenant`) — see API_ISSUES.md #14. We always
// emit ONE casing from the interceptor; HTTP header names are case-insensitive
// so the backend accepts it regardless.
export const TENANT_HEADER = "X-Tenant";

// Storage keys — kept in lockstep with the legacy layer (see authHelpers.js).
export const STORAGE_KEYS = {
  token: "token", // localStorage — Bearer token
  user: "user", // sessionStorage — JSON user blob
  tenant: "tenant", // sessionStorage — subdomain string
  authType: "auth_type", // sessionStorage — "tenant" | "employee"
};

// Default request timeout (ms). Generous because some report/list endpoints
// on staging are slow.
export const REQUEST_TIMEOUT = 30000;

// TanStack Query cache tiers (ms). Picked per data volatility:
//  - reference: rarely changes (countries, system codes, currencies)
//  - list:      changes often (orders, transactions)
//  - detail:    a single record
//  - realtime:  always refetch (dashboards, active session, kitchen board)
export const STALE_TIME = {
  reference: 60 * 60 * 1000, // 1 hour
  list: 30 * 1000, // 30 seconds
  detail: 60 * 1000, // 1 minute
  realtime: 0, // always stale
};

export const GC_TIME = 5 * 60 * 1000; // 5 minutes (cache retention)
